import * as Yup from 'yup';

export const getReturnSchema = (isReturn: boolean) => {
	const swapReturnTypes = ['gift-swap', 'return-swap'];
	const isSwapReturnType = (returnType: any) => {
		const value = typeof returnType === 'string' ? returnType : returnType?.value;
		return swapReturnTypes.includes(value);
	};

	return Yup.object().shape({
		returnType: isReturn ? Yup.mixed().required('step-conformation.return-type-required') : Yup.mixed().nullable(),
		returnOrderId: isReturn
			? Yup.number()
					.positive('step-conformation.return-order-id-positive')
					.required('step-conformation.return-order-id-required')
			: Yup.number().nullable(),
		returnProduct: isReturn
			? Yup.string().trim().required('step-conformation.return-product-required')
			: Yup.string().nullable(),
		returnReason: Yup.string()
			.trim()
			.nullable()
			.when('returnType', {
				is: returnType => isReturn && isSwapReturnType(returnType),
				then: schema => schema.required('step-conformation.return-reason-required'),
			}),
	});
};
